import * as React from 'react';
import {
  OneColumnStaticPageGrammar,
  oneColumnVariantsGrammar,
} from '../landing/components/OneColumnStaticPageGrammar';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';

export const GioiThieuGrammarPage = (props: any) => {
  return (
    <OneColumnStaticPageGrammar {...props}>
      <div className="mb-24 center">
        <ResponsiveTypography.Title level={1} {...oneColumnVariantsGrammar.h1}>
          GIỚI THIỆU VỀ DOL GRAMMAR
        </ResponsiveTypography.Title>
      </div>
      <div className="mb-24">
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.paragraph}>
          DOL Grammar là website chuyên ngữ pháp tiếng Anh cung cấp đầy đủ kiến thức về lý thuyết, bài tập, tài liệu và
          công cụ kiểm tra ngữ pháp tiếng Anh.
          Sứ mệnh của DOL Grammar là hỗ trợ học sinh, sinh viên, giáo viên hay bất kỳ ai quan tâm đến ngữ pháp tiếng Anh
          có thể cải thiện và nâng cao kỹ năng ngữ pháp của mình.
        </ResponsiveTypography.Paragraph>
      </div>

      <div className="mb-16">
        <ResponsiveTypography.Title level={2} {...oneColumnVariantsGrammar.h2}>
          DOL Grammar phù hợp với đối tượng nào?
        </ResponsiveTypography.Title>
      </div>
      <div className="mb-24">
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.highlight}>
          DOL Grammar phù hợp với tất cả mọi người quan tâm đến ngữ pháp tiếng Anh đặc biệt là:
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.paragraph}>
          - Học sinh, sinh viên
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.paragraph}>
          - Người đang trong quá trình ôn luyện đề tiếng Anh để tham gia các kỳ thi THPT Quốc Gia, chứng chỉ IELTS,
          TOEIC,...
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.paragraph}>
          - Giáo viên đang cần soạn giáo án, bổ sung tài liệu giảng dạy cho trẻ em,học sinh,...
        </ResponsiveTypography.Paragraph>
      </div>

      <div className="mb-16">
        <ResponsiveTypography.Title level={2} {...oneColumnVariantsGrammar.h2}>
          Sứ mệnh của DOL Grammar
        </ResponsiveTypography.Title>
      </div>
      <div className="mb-24">
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.highlight}>
          Với phương châm luôn đặt lợi ích và thành công của người học lên hàng đầu. Bởi lẽ đó chúng tôi hướng đến các
          sứ mệnh:
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.paragraph}>
          - Trở thành nền tảng cung cấp kho tài liệu miễn phí về ngữ pháp Tiếng Anh chất lượng cao, dễ hiểu hàng đầu tại
          Việt Nam.
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.paragraph}>
          - Tạo ra một môi trường học tập trực tuyến thân thiện, dễ tiếp cận và hữu ích, giúp người học tiếng Anh phát
          triển và nâng cao kỹ năng ngữ pháp của mình.
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.paragraph}>
          - Kết hợp cùng hệ thống DOL English để trở thành hệ sinh thái học Tiếng Anh tư duy hàng đầu dành cho người
          Việt.
        </ResponsiveTypography.Paragraph>
      </div>

      <div className="mb-16">
        <ResponsiveTypography.Title level={2} {...oneColumnVariantsGrammar.h2}>
          Bạn sẽ nhận được gì tại DOL Grammar?
        </ResponsiveTypography.Title>
      </div>
      <div className="mb-16">
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.paragraph}>
          Tại DOL Grammar, chúng tôi cam kết mang đến cho bạn những lợi ích sau đây:
        </ResponsiveTypography.Paragraph>
      </div>

      <div className="mb-12">
        <ResponsiveTypography.Title level={3} {...oneColumnVariantsGrammar.h3}>
          Hệ thống lý thuyết và bài tập ngữ pháp Tiếng Anh
        </ResponsiveTypography.Title>
      </div>
      <div className="mb-24">
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.paragraph}>
          Hệ thống lý thuyết và bài tập ngữ pháp Tiếng Anh được biên soạn tối ưu nhất không chỉ giúp bạn hiểu
          mà còn phải vận dụng vào các bài tập một cách linh hoạt, chính xác.
          Các bài viết tại DOL Grammar sẽ cung cấp kiến thức chuyên sâu từng điểm ngữ pháp và phân tích những lỗi có thể
          gặp trong quá trình học Tiếng Anh
          kèm nhiều bài tập thực hành có đáp án để bạn áp dụng kiến thức đã học và rèn kỹ năng ngữ pháp của mình.
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.paragraph}>
          Ngoài ra, hệ thống lý thuyết và bài tập tại DOL Grammar được biên soạn từ đội ngũ có chuyên môn học thuật cao
          cùng với kinh nghiệm đứng lớp giảng dạy nên sẽ dễ dàng truyền đạt thông tin đến người đọc một cách dễ hiểu
          nhất.
        </ResponsiveTypography.Paragraph>
      </div>

      <div className="mb-12">
        <ResponsiveTypography.Title level={3} {...oneColumnVariantsGrammar.h3}>
          Công cụ check ngữ pháp Tiếng Anh chuẩn xác
        </ResponsiveTypography.Title>
      </div>
      <div className="mb-24">
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.paragraph}>
          Công cụ kiểm tra ngữ pháp chuẩn xác là một điểm mới tại DOL Grammar - được thiết kế để kiểm tra và đánh giá độ
          chính xác điểm ngữ pháp trong văn bản Tiếng Anh.
          Với công cụ này, bạn có thể nhập câu hoặc đoạn văn của mình và công cụ sẽ phân tích và xác định các lỗi ngữ
          pháp có thể có.
          Công cụ này sẽ giải thích chi tiết về nguyên tắc ngữ pháp và đề xuất sửa lỗi cụ thể.
          Điều này giúp bạn tự tin hơn trong việc viết và giao tiếp bằng tiếng Anh, đồng thời nâng cao khả năng tự sửa
          lỗi và cải thiện kỹ năng ngữ pháp của mình.
        </ResponsiveTypography.Paragraph>
      </div>

      <div className="mb-12">
        <ResponsiveTypography.Title level={3} {...oneColumnVariantsGrammar.h3}>
          Sở hữu kho tài liệu ngữ pháp tiếng anh giá trị
        </ResponsiveTypography.Title>
      </div>
      <div className="mb-24">
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.paragraph}>
          Kho tài liệu ngữ pháp Tiếng Anh giá trị sẽ cung cấp cho bạn những kiến thức và chi tiết về các quy tắc, cấu
          trúc và ngữ cảnh sử dụng ngữ pháp phù hợp.
          Giúp bạn nắm vững và hiểu rõ cách áp dụng từ đó sẽ cải thiện kỹ năng nghe, nói, đọc và viết trong Tiếng Anh.
          Đem lại sự tự tin trong việc sử dụng Tiếng Anh hằng ngày một cách linh hoạt.
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.paragraph}>
          Chúng tôi liên tục cập nhật kho tài liệu để đảm bảo bạn có thể tiếp cận thông tin mới nhất và đáng tin cậy.
          Kho tài liệu ngữ pháp tiếng Anh của chúng tôi sẽ là nguồn cảm hứng và hỗ trợ đáng tin cậy cho việc nâng cao
          khả năng sử dụng ngôn ngữ của bạn.
        </ResponsiveTypography.Paragraph>
      </div>

      <div className="mb-12">
        <ResponsiveTypography.Title level={3} {...oneColumnVariantsGrammar.h3}>
          Theo dõi được tiến độ học tập của bản thân
        </ResponsiveTypography.Title>
      </div>
      <div className="mb-24">
        <ResponsiveTypography.Paragraph {...oneColumnVariantsGrammar.paragraph}>
          Tại DOL Grammar, chúng tôi có tính năng đăng nhập tài khoản để giúp bạn có thể theo dõi được tiến độ học tập
          của bản thân. Bạn có thể xem được số bài lý thuyết đã đọc, lượng bài tập đã hoàn thành để có cái nhìn tổng
          quan về quá trình học tập của mình. Điều này giúp bạn tự đánh giá và thúc đẩy quá trình học tập của mình một
          cách hiệu quả. Việc theo dõi tiến độ học tập sẽ giúp bạn duy trì động lực và đạt được kết quả tốt hơn trong
          việc nắm vững ngữ pháp tiếng Anh.
        </ResponsiveTypography.Paragraph>
      </div>
    </OneColumnStaticPageGrammar>
  );
};
